<template>
    <div class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <div class="modal-header p-2" style="height:64px">
                <h4 class="modal-title"><span>&#127881; </span><span>NEW UPDATE !!</span>
                    <span> &#127881;</span>
                </h4>
                </div>
                <div class="modal-body p-0">
                    <div class="row h-100">
                        <div class="col-md-8" style="height:100%">
                            <div style="height:100%;width:100%">
                                <img :src="getProxyConvertedURL(selectedItem.image_path)" @error="replaceByDefaultImage"  style="width:100%;height:100%;object-fit: contain;"/>
                            </div>
                        </div>
                        <div class="col-md-4 h-100" style="overflow:auto">
                            <div v-for="(item,index) in updatesGuide.info" :key="index" @click="selectItem(item,index)" :class="{active:selectedIndex == index && updatesGuide.info.length > 1}" style="padding-bottom:20px !important;padding:10px">
                                <div style="font-size:20px;" class="update-title"><span v-if="updatesGuide.info.length > 1">{{index+1}}. </span>{{item.title}}</div>
                                <div style="color: #bbb;" class="update-description">{{item.description}}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer p-0" style="display: flex;justify-content: space-between;flex-direction: row;flex-wrap: inherit;">
                <div class="primary-btn-style">
                    <button v-if="updatesGuide.info.length > 1 && selectedIndex > 0" @click="goToPreviousUpdate()" class="btn btn-outline-warning mr-3 ml-3" data-dismiss="modal" style="width:auto">Previous</button>
                    <button
                    v-if="updatesGuide.info.length > 1 && selectedIndex < updatesGuide.info.length - 1"
                    @click="goToNextUpdate()"
                    class="btn btn-outline-warning mr-3 ml-3"
                    data-v-198e7d7f=""
                    style="position: relative; inset-inline-end :0"
                    >
                    Next
                    </button>
                </div>
                <div class="primary-btn-style">
                    <button
                    v-on:click.stop.prevent="readTheUpdateGuide()"
                    class="btn btn-warning mr-3 gotIt-btn"
                    data-v-198e7d7f=""
                    style="position: relative; float: inline-end; inset-inline-end :0"
                    >
                    Got it
                    </button>
                    <button v-if="selectedItem.learn_more_url && selectedItem.learn_more_url.length" class="btn btn-outline-light mr-3 learnmore-btn" data-dismiss="modal"  style="width:auto;border:none;float:inline-end"><a :href="selectedItem.learn_more_url" target="_blank" style="color: unset;">Learn more</a></button>
                </div>
            </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapMutations } from "vuex";
    import Utils from "../../components.utils.js";

    export default {
        props:["updatesGuide"],
        data(){
            return{
                selectedItem:null,
                selectedIndex:0
            }
        },
        watch:{
            updatesGuide(value){
                this.selectedItem = value.info[0];
            }
        },
        methods:{
            replaceByDefaultImage(e){
                e.target.onerror = null
                e.target.src = Utils.getNoThumbnailImg();
            },
            selectItem(data,index){
                this.selectedItem = data;
                this.selectedIndex = index;
            },
            goToPreviousUpdate(){
                this.selectedIndex = this.selectedIndex-1;
                this.selectedItem = this.updatesGuide.info[this.selectedIndex];
            },
            goToNextUpdate(){
                this.selectedIndex = this.selectedIndex + 1;
                this.selectedItem = this.updatesGuide.info[this.selectedIndex];
            },
            readTheUpdateGuide(){
                console.log("this.updatesGuidethis.updatesGuide",this.updatesGuide)
                let payload = {"_id":this.updatesGuide._id}
                this.updateReadStatusOfNewUpdates(payload).then((data) => {
                if (Utils.isAcceptedStatusCode(data.statusCode)) {
                        this.$emit("close");
                        this.unsetNewUpdatesPageData(this.updatesGuide)
                    } else {
                        this.$toast.error("Failed !!");
                    }   
                })
                },
            ...mapActions("actions",["updateReadStatusOfNewUpdates"]),
            ...mapMutations("actions",["unsetNewUpdatesPageData"])
        },
        created(){
            this.selectedItem = this.updatesGuide.info[0];
        }
    }
</script>

<style scoped lang="scss">
$table-row-border: none;
$active-blue: #007bff;
$danger-color: #dc3545;
$none-text-color:#4f4f4f;
$add-button-text-color:#0b7099;
$add-button-text-color-hover:#0193cc;
$add-button-border-color:#b7b228;
$add-button-border-on-hover:#dcd426;
$add-button-backgroud:#1e1e1e;
$active-green-color:#28a745;
$primary-background: #0b3630;
$border-color: 1px solid #4a4a4a;
$secondary-background-color:#0b3630;
$bg-color-on-hover: #22272b;
$text-color: #eee;
$dull-text-color: #757575;
$secondary-text-color: #9c9c9c;
$active-blue : #007bff;
$input-field-and-label-font-size:14px;
$input-field-height:38px;
$highlight-font-color:#ff9800;
$scrollbar-thumb-background:#333;
$scrollbar-track-background:#1a1e21;
$scrollbar-thumb-on-hover-background:#555; 
$input-field-padding:.375rem 10px;
$filter-border-color: #5a5a5a;
$filter-bg-color: #2a2a2a;
$learn-about-text-color-hover:#b7b327;
$learn-about-text-color:#9a9620;
$tags-background-color:#282d31;
$svg-color:#666;
$tags-border-color:#363636;
$secondary-border-color: 1px solid #464646;

.modal-dialog {
    max-width: calc(100% - 200px);
    width: calc(100% - 200px);
    height: calc(100% - 50px);
    margin: 0;
    padding: 0;
    cursor: pointer;
  }
  
  .modal-content {
    height: auto;
    min-height: 100%;
    border-radius: 0;
    box-shadow: none;
    background: $primary-background !important;
    border: $secondary-border-color;
    border-radius: 20px;
    .modal-body{
      background: $primary-background;
      height: 300px;
      user-select: text !important; 
      color: $text-color !important;
    }
  }

.modal {
    text-align: center;
    padding: 0 !important;
    display: block;
    position: fixed;
    inset-inline-start: 0px;
    top: 5%;
}
.modal:before {
    content: "";
    display: inline-block;
    height: 100vh;
    vertical-align: middle;
    margin-inline-end: -4px;
    position: fixed;
    width: 100vw;
    inset-inline-start: 0;
    top: 0;
    background: #00000094;
}
.modal:before {
  content: '';
  display: inline-block;
  height: 100%;
  vertical-align: middle;
  margin-inline-end: -4px;
}
.modal-dialog {
  display: inline-block;
  text-align: start;
  vertical-align: middle;
}

.modal-header,.modal-footer{
    border-top: $secondary-border-color !important;
    border-bottom: $secondary-border-color !important;
    background: $secondary-background-color;
    border-radius: 15px;
    .modal-title{
      color:$text-color;
      padding: 8px;
    }
}

.modal-header{
    border-bottom-right-radius: 0px;
    border-bottom-left-radius: 0px;
    border-top: none !important;
}

.modal-footer{
    border-top-right-radius: 0px;
    border-top-left-radius: 0px;
    border-bottom: none !important;
}

.modal-header .close {
    margin: -1rem -13px -1rem auto !important;
}

.close-icon:hover{
  background: #373737;
  border-radius: 20px;
}
.active{
    // color: $active-blue !important;
    border: 1px solid #606060;
    border-radius: 5px;
    .update-title{
        font-size: 24px !important;
    }
    .update-description{
        font-size: 16px !important;
    }
}

.user-name-or-image{
    height: 60px;
    width: 60px;
    border: $border-color;
    border-radius: 10px;
    text-align: center;
    line-height: 56px;
    text-transform: uppercase;
    margin: 0 auto;
    font-size: 30px;
}

.primary-btn-style {
  margin-top: 1%;
  bottom: 8px;
  inset-inline-end: 0%;
  height:50px;
  width:100%;
  z-index:9;
  button {
    height: 38px !important;
    width: 70px;
    font-size:14px;
    margin-top:7px;
  }
  .btn-outline-secondary{
    float:inline-end;
  }
  .btn-outline-primary{
    margin-inline-end:15px;
  }
}

a:hover{
    color: unset;
}


 ::-webkit-scrollbar {
    width: 8px;
    height:8px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: $secondary-background-color;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: $primary-background;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: $bg-color-on-hover;
  }

  .learnmore-btn:hover{
      background: transparent;
      color:unset;
  }
  
  .gotIt-btn:hover{
      color: #fff !important;
  }

</style>